import { FormBuilder, ReactiveFormsModule } from "@angular/forms";

import { Component, inject, OnInit, signal } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { environment } from "src/environments/environment";
import { DeliveryNote } from "../_models";
import { WarehouseService } from "../_services";

@Component({
  imports: [ReactiveFormsModule, RouterModule],
  selector: "hawk-warehouse-retoure",
  templateUrl: "./warehouse-retoure.component.html",
  styleUrls: ["./warehouse-retoure.component.scss"],
  host: {
    class: "app-page",
  },
})
export class WarehouseRetoureComponent implements OnInit {
  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private service = inject(WarehouseService);

  protected form = this.fb.group({
    warehouse_id: this.fb.control<string>({
      value: this.route.snapshot.paramMap.get("id"),
      disabled: false,
    }),
    parcel_weight: this.fb.control<number>({ value: null, disabled: false }),
    parcel_length: this.fb.control<number>({ value: null, disabled: false }),
    parcel_width: this.fb.control<number>({ value: null, disabled: false }),
    parcel_height: this.fb.control<number>({ value: null, disabled: false }),
  });

  env = environment;

  protected status = signal<"new" | "error" | "sending">("new");
  protected errorText = signal<string>("");
  protected returnJobs = signal<DeliveryNote[]>([]);

  public ngOnInit(): void {
    this.resetForm();
  }

  protected resetForm(): void {
    this.form.setValue({
      warehouse_id: this.route.snapshot.paramMap.get("id"),
      parcel_weight: null,
      parcel_length: null,
      parcel_width: null,
      parcel_height: null,
    });
  }

  protected onSubmit() {
    const value = this.form.getRawValue();
    console.log(value);
    this.status.set("sending");

    this.service.createIntRetoure(value).subscribe({
      next: (res) => {
        console.log(res);
        this.returnJobs.set([...this.returnJobs(), res]);
        this.form.reset();
        this.resetForm();
        this.status.set("new");
      },
      error: (err) => {
        console.error(err);
        this.status.set("error");
        this.errorText.set("es ist etwas schief gegangen.");
      },
    });
  }
}
